import React from "react";
import { Route, Switch } from "react-router-dom";
// No logged
import App from "../App";
import LoginPage from "../screens/LoginScreen";
import ResetPasswordPage from "../screens/ResetPasswordPage";
// ACCOUNT
import Settings from "../screens/settings/Show";
// SIDEBAR
import Sidebar from "Components/sidebar/Sidebar";
// ARCHIVE
import Archive from "../screens/archive/List";
import ArchiveNewDomain from "../screens/archive/NewDomain";
import ArchiveDomainShow from "../screens/archive/Show";
import ArchiveDomainSettings from "../screens/archive/Settings";
import ArchiveEmailAccountList from "../screens/archive/emailAccounts/List";
import ArchiveEmailAccountShow from "../screens/archive/emailAccounts/Show";
// DELEGATES
import DelegatesList from "../screens/delegates/List";
import NewDelegate from "../screens/delegates/New";
import DelegateShow from "../screens/delegates/Show";
// DOMAINS
import DomainsList from "../screens/domains/List";
import DomainNew from "../screens/domains/New";
import DomainShow from "../screens/domains/Show";
import OwnershipCheck from "../screens/OwnershipCheck";
import DomainSettingsPage from "../screens/domains/Settings";
// POSTMASTER
import PostmasterPage from "../screens/domains/Postmaster";
import PostmasterList from "../screens/postmasters/List";
// EMAIL ACCOUNTS
import EmailAccountNew from "../screens/emailAccounts/New";
import EmailAccount from "../screens/emailAccounts/Show";
import EmailAccountsList from "../screens/emailAccounts/List";
import EmailAccountSettings from "../screens/emailAccounts/Settings";
// ALIAS DOMAINS
import AliasDomainsList from "../screens/aliasDomains/List";
import AliasDomainsNew from "../screens/aliasDomains/New";
// ALIAS EMAIL ACCOUNTS
import AliasEmailAccountsList from "../screens/aliasEmailAccounts/List";
import AliasEmailAccountsNew from "../screens/aliasEmailAccounts/New";
// ORDERS
import OrderNew from "../screens/orders/New";
import OrderShow from "../screens/orders/Show";
// IMPORTS
import ImportsList from "../screens/imports/List";
import ImportsAdd from "../screens/imports/New";
import ImportResourcesList from "../screens/imports/Resources";
// MIGRATIONS
import MigrationsList from "../screens/migrations/List";
import MigrationsAdd from "../screens/migrations/New";
import MigrationResourcesList from "../screens/migrations/Resources";
// AUDITS
import AuditsList from "../screens/audits/List";
// DASHBOARD
import DashboardPage from "../screens/dashboard/Dashboard";
// CUSTOMIZATIONS
import CustomizationsList from "../screens/customizations/List";
import CustomizationsShow from "../screens/customizations/Show";
import CustomizationsAdd from "../screens/customizations/New";

import ServerMissing from "Components/ServerMissing";
import NotFound from "Components/NotFound";
// ETLIVE
import ETLive from "../screens/etlive/List";
import qs from "query-string";

// Delivery
import DeliveryDashboard from "../screens/delivery/dashboard/Dashboard.jsx";
import DeliveryDomains from "../screens/delivery/domains/List.jsx";
import DeliveryDomainsNew from "../screens/delivery/domains/New.jsx";
import DeliveryDomainShow from "../screens/delivery/domains/Show.jsx";
import DeliveryAccounts from "../screens/delivery/accounts/List.jsx";
import DeliveryAccountsNew from "../screens/delivery/accounts/New.jsx";
import DeliveryAccountsShow from "../screens/delivery/accounts/Show";
import DeliveryAccountsUpdate from "../screens/delivery/accounts/Update";
import DeliveryAnalytics from "../screens/delivery/accounts/Analytics";
import SuppressionList from "../screens/delivery/suppressionList/List";
import SuppressionListNew from "../screens/delivery/suppressionList/New";
import SuppressionListImport from "../screens/delivery/suppressionList/Import";
import SuppressionListShow from "../screens/delivery/suppressionList/Show";
import DeliveryAccessRequest from "../screens/delivery/accessRequest/Show";
import DeliveryMaintenance from "../screens/delivery/Maintenance";
import DeliveryTracemail from "../screens/delivery/tracemail/Show";

export default (props) => (
  <div>
    <Route path="/manteinance" component={ServerMissing} />

    <Route path="/login" component={LoginPage} />
    <Route path="/users/:userCode/reset_password" component={ResetPasswordPage} />

    <Route
      path="/"
      render={(routerProps) => {
        const p = { ...props, ...routerProps };

        // add location.query to the props
        p.location.query = qs.parse(p.location.search);

        let canAccessDelivery = true; //p.loggedUser?.delivery_waitlist_accepted_on;

        const env = process.env.NODE_ENV;
        if (env === "production" && location.hostname === "sandbox.qboxmail.com") {
          canAccessDelivery = false;
        }

        return (
          <Sidebar {...p}>
            <Switch>
              <Route exact path="/" component={DashboardPage} />
              <Route exact path="/home" component={DashboardPage} />
              // Linked email account management
              <Route
                {...p}
                path="/email_account"
                render={(props) => {
                  const subProps = { ...p, ...props };

                  return (
                    <EmailAccount
                      {...subProps}
                      render={(componentProps) => {
                        return (
                          <Route
                            {...p}
                            exact
                            path="/email_account/settings"
                            render={() => <EmailAccountSettings {...{ ...p, ...componentProps }} />}
                          />
                        );
                      }}
                    />
                  );
                }}
              />
              <Route exact path="/account" component={Settings} />
              <Route exact path="/audits" component={AuditsList} />
              <Route exact path="/migrations" component={MigrationsList} />
              <Route exact path="/migrations/add" component={MigrationsAdd} />
              <Route exact path="/migrations/:migrationCode/resources" component={MigrationResourcesList} />
              <Route exact path="/imports" component={ImportsList} />
              <Route exact path="/imports/:importCode/resources" component={ImportResourcesList} />
              <Route exact path="/imports/add" component={ImportsAdd} />
              <Route exact path="/customizations" component={CustomizationsList} />
              <Route exact path="/customizations/:customizationId" component={CustomizationsShow} />
              <Route exact path="/customizations/main/add" component={CustomizationsAdd} />
              <Route
                exact
                path="/domains/:domainCode/aliases/:aliasDomainCode/ownership_check"
                component={OwnershipCheck}
              />
              <Route exact path="/domains/:domainCode/ownership_check" component={OwnershipCheck} />
              <Route exact path="/domains/new" component={DomainNew} />
              <Route exact path="/domains" component={DomainsList} />
              <Route exact path="/domains/:domainCode/email_accounts/add" component={EmailAccountNew} />
              <Route
                path="/domains/:domainCode/email_accounts/:emailCode"
                render={(props) => {
                  const subProps = { ...p, ...props };
                  return (
                    <EmailAccount
                      {...subProps}
                      render={(componentProps) => {
                        return (
                          <Route
                            exact
                            path="/domains/:domainCode/email_accounts/:emailCode/settings"
                            render={() => <EmailAccountSettings {...{ ...p, ...componentProps }} />}
                          />
                        );
                      }}
                    />
                  );
                }}
              />
              <Route
                path="/domains/:domainCode"
                render={(props) => {
                  const subProps = { ...p, ...props };

                  return (
                    <DomainShow {...subProps}>
                      <Switch>
                        <Route exact path="/domains/:domainCode/aliases" component={AliasDomainsList} />
                        <Route exact path="/domains/:domainCode/aliases/add" component={AliasDomainsNew} />
                        <Route
                          exact
                          path="/domains/:domainCode/alias_email_accounts"
                          component={AliasEmailAccountsList}
                        />
                        <Route
                          exact
                          path="/domains/:domainCode/alias_email_accounts/add"
                          component={AliasEmailAccountsNew}
                        />
                        <Route exact path="/domains/:domainCode/settings" component={DomainSettingsPage} />
                        <Route exact path="/domains/:domainCode/email_accounts" component={EmailAccountsList} />
                        <Route
                          exact
                          path="/domains/:domainCode/postmaster/:postmasterCode"
                          component={PostmasterPage}
                        />
                      </Switch>
                    </DomainShow>
                  );
                }}
              />
              <Route exact path="/postmasters" component={PostmasterList} />
              <Route exact path="/orders" component={OrderShow} />
              <Route exact path="/orders/new" component={OrderNew} />
              <Route exact path="/tracemail" component={ETLive} />
              <Route exact path="/delegates" component={DelegatesList} />
              <Route exact path="/delegates/new" component={NewDelegate} />
              <Route exact path="/delegates/:delegateCode" component={DelegateShow} />
              <Route exact path="/archive" component={Archive} />
              <Route exact path="/archive/new" component={ArchiveNewDomain} />
              <Route exact path="/archive/domains/:domainCode/email_accounts/new" component={ArchiveNewDomain} />
              <Route
                exact
                path="/archive/domains/:domainCode/email_accounts/:emailCode"
                component={ArchiveEmailAccountShow}
              />
              <Route
                path="/archive/domains/:domainCode"
                render={(props) => {
                  const subProps = { ...p, ...props };

                  return (
                    <ArchiveDomainShow {...subProps}>
                      <Switch>
                        <Route
                          exact
                          path="/archive/domains/:domainCode/email_accounts"
                          component={ArchiveEmailAccountList}
                        />
                        <Route exact path="/archive/domains/:domainCode/settings" component={ArchiveDomainSettings} />
                      </Switch>
                    </ArchiveDomainShow>
                  );
                }}
              />
              {canAccessDelivery ? (
                <Switch>
                  <Route exact path="/delivery" component={DeliveryDashboard} />
                  <Route exact path="/delivery/access-request" component={DeliveryAccessRequest} />
                  <Route exact path="/delivery/domains" component={DeliveryDomains} />
                  <Route exact path="/delivery/domains/new" component={DeliveryDomainsNew} />
                  <Route path="/delivery/domains/:domainCode" component={DeliveryDomainShow} />
                  <Route exact path="/delivery/accounts" component={DeliveryAccounts} />
                  <Route exact path="/delivery/accounts/new" component={DeliveryAccountsNew} />
                  <Route path="/delivery/accounts/update/:accountCode" component={DeliveryAccountsUpdate} />
                  <Route path="/delivery/accounts/extra-delivery/:accountCode" component={DeliveryAccountsUpdate} />
                  <Route path="/delivery/accounts/change-plan/:accountCode" component={DeliveryAccountsUpdate} />
                  <Route path="/delivery/accounts/:accountCode/analytics" component={DeliveryAnalytics} />
                  <Route path="/delivery/accounts/:accountCode" component={DeliveryAccountsShow} />

                  <Route exact path="/delivery/suppression-list" component={SuppressionList} />
                  <Route exact path="/delivery/suppression-list/new" component={SuppressionListNew} />
                  <Route exact path="/delivery/suppression-list/import" component={SuppressionListImport} />
                  <Route exact path="/delivery/suppression-list/:email" component={SuppressionListShow} />
                  <Route path="/delivery/tracemail" component={DeliveryTracemail} />

                  <Route exact path="*" component={NotFound} />
                </Switch>
              ) : (
                <Switch>
                  <Route exact path="/delivery/access-request" component={DeliveryAccessRequest} />
                  <Route exact path="*" component={NotFound} />
                </Switch>
              )}
              <Route exact path="*" component={NotFound} />
            </Switch>
          </Sidebar>
        );
      }}
    />
  </div>
);
